export { default } from "./BrickedOffDoorIcon";
